import { render, staticRenderFns } from "./add-content-dialog.vue?vue&type=template&id=be895a1c"
import script from "./add-content-dialog.vue?vue&type=script&lang=js"
export * from "./add-content-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports